import { shape, number, string } from 'prop-types'

const ageRestrictionType = shape({
  id: number,
  name: string,
})

export default ageRestrictionType
